import type { BannerCarrosselProps } from "../../banner-carrossel.props"

interface BannerMidiaProps {
    banner: BannerCarrosselProps
    width: number
    height: number
    idx: number
    isFirst: boolean
}

export function BannerCarrosselMidia({ banner, width, height, idx, isFirst }: BannerMidiaProps) {
    const parsed = (() => {
        try {
            return typeof banner.midia_opcoes === 'string'
            ? JSON.parse(banner.midia_opcoes)
            : banner.midia_opcoes
        } catch {
            return undefined
        }
    })()

    const widthImg  = parsed?.original?.width ?? 0
    const heightImg = parsed?.original?.height ?? 0

    return (
        (banner.automatico && banner.valida_estoque) ? (
            banner.produto.midias.map((midiaProduto) => (
                <div key={midiaProduto.id_midia} className="imagem-produto">
                    <img
                        src={isFirst ? midiaProduto.midiaUrl : midiaProduto.url_hint_banner}
                        data-src={midiaProduto.midiaUrl}
                        alt={midiaProduto.midia_alt}
                        className={isFirst ? undefined : "lazyload"}
                        {...(Number(width) > 0 ? { width: width } : {})}
                        {...(Number(height) > 0 ? { height: height } : {})}
                        style={
                            widthImg > 0 && heightImg > 0
                            ? { aspectRatio: `${widthImg} / ${heightImg}` }
                            : undefined
                        }
                    />
                </div>
            ))
        ) : (banner.nome?.endsWith(".mp4") || banner.path?.endsWith(".mp4") ? (
                <video
                    key={idx}
                    src={banner.url_video_banner}
                    className="lazyload"
                    preload="none"
                    muted
                    loop
                    playsInline
                    data-autoplay=""
                />
            ) : (
                <figure>
                    <img
                        key={idx}
                        src={isFirst ? banner.midiaUrl : banner.url_hint_banner}
                        data-src={banner.midiaUrl}
                        alt={banner.midia_alt}
                        title={banner.legenda || banner.midia_title}
                        className={isFirst ? undefined : "lazyload"}
                        {...(Number(widthImg) > 0 ? { width: widthImg } : {})}
                        {...(Number(heightImg) > 0 ? { height: heightImg } : {})}
                        style={
                            widthImg > 0 && heightImg > 0
                            ? { aspectRatio: `${widthImg} / ${heightImg}` }
                            : undefined
                        }
                    />
                </figure>
            )
        )
    )
}
